import React, { useEffect } from 'react';
import HeroDirectorHero from '../components/HeroDirectorHero';
import HeroPortfolio from '../components/HeroPortfolio';
import AreasOfFocus from '../components/AreasOfFocus';
import BrandsCollaborated from '../components/BrandsCollaborated';
import RecognitionWorkshops from '../components/RecognitionWorkshops';
import DirectorBio from '../components/DirectorBio';
import ContactCollaboration from '../components/ContactCollaboration';

const HeroHomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroDirectorHero />
      <HeroPortfolio />
      <AreasOfFocus />
      <BrandsCollaborated />
      <RecognitionWorkshops />
      <DirectorBio />
      <ContactCollaboration />
    </div>
  );
};

export default HeroHomePage;